import { z } from 'zod';
import {
  AdminDocDivision,
  AdminDocDepartment,
  AdminDocStatus,
  ADMIN_DOC_DEPARTMENTS,
} from './admin-doc.model';

export interface CreateAdminDocRequest {
  name: string;
  division: AdminDocDivision;
  department: AdminDocDepartment;
  status: AdminDocStatus;
  description: string;
  documents: {
    fileName: string;
    fileUrl: string;
    uploadedBy: string;
    uploadedBySub: string;
    uploadedAt: number;
  }[];
}

export const CreateAdminDocRequestSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  division: z.enum([AdminDocDivision.CCL, AdminDocDivision.TSF, AdminDocDivision.Company, AdminDocDivision.OnboardingCCL, AdminDocDivision.OnboardingTSF]),
  department: z.enum(ADMIN_DOC_DEPARTMENTS),
  status: z.enum([AdminDocStatus.Open, AdminDocStatus.Done]),
  description: z.string(),
  documents: z.array(
    z.object({
      fileName: z.string(),
      fileUrl: z.string(),
      uploadedBy: z.string(),
      uploadedBySub: z.string(),
      uploadedAt: z.number(),
    })
  ),
});
